import Head from 'next/head';
import { NextSeo } from 'next-seo';

//screen
import { Demo } from '@/screens/ShipperGuide';

export default function DemoPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Freight shipping, shipper services, logistics shipping, freight brokerage, shipper technology, shipping software, FTL shipping, LTL shipping, multimodal shopping, PTL, drayage, rail shipping, supply chain services, shipper software, software for shipping, online shipping software, freight management, freight procurement, freight management services, logistics freight management"
        />
      </Head>

      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="ShipperGuide TMS Request a Demo - Freight Management Software"
        description="All in one freight shipping software, ShipperGuide TMS, offers an easy-to-use platform that enables planning, procurement, and freight execution."
        canonical="https://loadsmart.com/shipper/shipperguide/demo/"
        openGraph={{
          url: 'https://loadsmart.com/shipper/shipperguide/demo/',
        }}
      />
      <Demo />
    </>
  );
}
